// client/src/coms/views/games_parts/gamesData.js
// Shapes shared by the Games destination: hosted (GameNest) sessions and party sessions as one list.
import { MODE_ICONS } from '../canvas_parts/party/partyMeta';

// Hosted sessions, party sessions and Watch Together activities in one list.
export function mergeSessions(hosted, party, entries, watch = [], meId = 0) {
  const byKey = new Map(entries.map((entry) => [entry.key, entry]));
  const out = [];
  (hosted || []).forEach((item) => {
    const entry = byKey.get(item.gameKey) || {};
    const host = item.seats.find((seat) => seat.userId === item.hostUserId) || item.seats[0] || {};
    out.push({
      kind: 'session',
      id: item.id,
      entryKey: item.gameKey,
      name: item.gameName,
      icon: entry.arcade && entry.icon ? entry.icon : '🎲',
      accent: entry.accent || '',
      hostUserId: item.hostUserId,
      hostName: host.name || '',
      players: item.seats.map((seat) => ({ userId: seat.userId, name: seat.name })),
      maxPlayers: item.maxPlayers,
      status: item.status,
      member: Boolean(item.seated),
      invited: Boolean(item.invited),
      visibility: item.visibility,
      serverId: Number(item.serverId) || 0,
      allowSpectators: false,
      allowLateJoin: false,
      createdAt: item.createdAt,
    });
  });
  (party || []).forEach((item) => {
    const entry = byKey.get(`party:${item.modeId}`) || {};
    out.push({
      kind: 'party',
      id: item.id,
      entryKey: `party:${item.modeId}`,
      name: item.modeName,
      icon: MODE_ICONS[entry.icon] || '🎨',
      accent: entry.accent || '',
      hostUserId: item.hostUserId,
      hostName: item.hostName,
      players: item.players,
      maxPlayers: item.maxPlayers,
      status: item.status,
      member: Boolean(item.member),
      invited: Boolean(item.invited),
      visibility: item.visibility,
      serverId: Number(item.serverId) || 0,
      allowSpectators: Boolean(item.allowSpectators),
      allowLateJoin: Boolean(item.allowLateJoin),
      createdAt: item.createdAt,
    });
  });
  (watch || []).forEach((item) => {
    out.push({
      kind: 'watch',
      id: item.id,
      entryKey: 'watch-together',
      name: item.voice ? `${item.title || 'Watch Together'} · 🔊 ${item.voice.channelName}` : item.title || 'Watch Together',
      title: item.title || 'Watch Together',
      icon: '📺',
      accent: '#e53935',
      hostUserId: item.hostUserId,
      hostName: item.hostName,
      players: item.participants.filter((p) => p.connected !== false).map((p) => ({ userId: p.userId, name: p.name })),
      maxPlayers: 0,
      status: 'live',
      member: Boolean(item.watching),
      invited: false,
      visibility: item.audience === 'invite' ? 'invite' : 'server',
      serverId: Number(item.serverId) || 0,
      allowSpectators: false,
      allowLateJoin: true,
      createdAt: item.createdAt,
      nowPlaying: item.nowPlaying,
    });
  });
  return out.sort((a, b) => Number(b.member) - Number(a.member) || Number(b.invited) - Number(a.invited) || b.createdAt - a.createdAt);
}
